export enum MODAL_STATE {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED'
}

export enum ITEM_LAYOUT {
    GRID = 'layout-grid',
    LIST = 'layout-list',
    GRID_MEDIUM = 'layout-grid-medium',
    GRID_LARGE = 'layout-grid-large'
}

export enum SITE_LAYOUT {
    DEFAULT = 'site-width-default',
    FULL_WIDTH = 'site-width-full'
}
